import React, { useState, useEffect } from "react";
import { Menubar } from "primereact/menubar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { fetchMemberships } from "./strapi/queries";
import { IconButton, Tooltip } from "@mui/material";

import LogoutIcon from "@mui/icons-material/Logout";
import logo from "./assets/logo_small.png";
import "./MainLayout.css";

export default function MainLayout({
  children,
  setUser,
  activeGroup,
  setActiveGroup,
  rootContainer,
  groupChangeKey,
  memberships, // Accept memberships as prop
  setMemberships, // Accept setMemberships as prop
}) {
  const [displayContactModal, setDisplayContactModal] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const items = [
    {
      label: "Ausrüstung & Prüfung",
      icon: "pi pi-box",
      command: () => navigate("/gear/" + rootContainer),
    },
    {
      label: "Prüfprotokolle",
      icon: "pi pi-check-square",
      command: () => navigate("/checkreport/" + activeGroup?.documentId),
    },
    {
      label: "Gruppenverwaltung",
      icon: "pi pi-users",
      command: () => navigate("/group-management"),
    },
    {
      label: "Kontakt",
      icon: "pi pi-envelope",
      command: () => setDisplayContactModal(true),
    },
  ];

  const start = (
    <div
      className="menubar-logo"
      onClick={() => navigate("/")}
      style={{ cursor: "pointer" }}
    >
      <img alt="Logo" src={logo} height="40" />
    </div>
  );

  const end = (
    <div
      className="menubar-end"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        marginLeft: "10px",
      }}
    >
      <Dropdown
        value={activeGroup ? activeGroup : "<keine Gruppen>"}
        options={
          memberships.memberships
            ? memberships.memberships.map((m) => m.group).filter((g) => g != null)
            : []
        }
        onChange={(e) => {
          setActiveGroup(e.value);
        }}
        optionLabel="name"
        // Key prop to force re-render when groupChangeKey changes
        key={groupChangeKey}
      />
      <Tooltip title="Ausloggen">
        <span>
          <IconButton
            variant="contained"
            color="primary"
            onClick={handleLogout}
            sx={{
              color: "white",
              border: "2px solid #10527e",
              backgroundColor: "#10527e",
              "&:hover": {
                border: "2px solid #282c34",
                backgroundColor: "#282c34",
              },
              "&.Mui-disabled": {
                backgroundColor: "#cccccc",
                color: "#666666",
              },
            }}
          >
            <LogoutIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );

  return (
    <div className="main-layout">
      <div className="menubar-container">
        <Menubar
          className="no-radius-menubar"
          model={items}
          start={start}
          end={end}
        />
      </div>
      <div className="main-content">
        {React.Children.map(children, (child) =>
          React.cloneElement(child, { groupChangeKey })
        )}
      </div>
      <footer className="main-footer">
        <div className="footer-content-wrapper">
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} Stefan Moosbrugger
          </div>
          <div className="footer-social">
            <a
              href="https://www.linkedin.com/in/stefanmoosbrugger/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="pi pi-linkedin"></i>
            </a>
            <a
              href="https://github.com/stefanmoosbrugger/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="pi pi-github"></i>
            </a>
          </div>
        </div>
      </footer>

      <Dialog
        header="Kontakt"
        visible={displayContactModal}
        style={{ width: "350px" }}
        onHide={() => setDisplayContactModal(false)}
      >
        <p>Stefan Moosbrugger</p>
        <p>A-6654 Holzgau</p>
        <p>Holzgau 94c</p>
        <p>stefanmoosbrugger@gmail.com</p>
      </Dialog>
    </div>
  );
}
